import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

import type { FC } from 'react'

interface PageGuardTimPenilaiProps {
  children: React.ReactNode
  type: 'TK' | 'PPK'
}

const PageGuardTimPenilai: FC<PageGuardTimPenilaiProps> = ({
  children,
  type,
}) => {
  const { isPPKPenilik, isTKPenilik, isLoading, leave } = useRoleContext()

  if (!isLoading) {
    // If the user is not a Tim Kinerja Penilik or PPK Penilik, leave the page
    if (!isTKPenilik && !isPPKPenilik) {
      leave()
    }

    if (type === 'TK' && !isTKPenilik) {
      // If we expect the user to be a TK but they are not, leave the page
      leave()
    } else if (type === 'PPK' && !isPPKPenilik) {
      // If we expect the user to be a PPK but they are not, leave the page
      leave()
    }
  }

  // As the component should not be rendered when still loading the user role, we can just return null
  if (isLoading) return null

  return <>{children}</>
}

export default PageGuardTimPenilai
